
export const DIMENSION_COLORS: Record<string, string> = {
    cuerpo: '#304E8F',
    mente: '#5C9DD6',
    conciencia: '#695EA6',
    energia: '#4FB08C'
};